/**
 * Writes text to the clipboard.
 * On native platforms, uses the native clipboard API.
 * On web, uses the browser clipboard API via navigator.clipboard.
 *
 * Note: Unlike most adapters, we don't gate this on isNativePlatform() because
 * @capacitor/clipboard has built-in web support via the Web Clipboard API.
 *
 * @param text - The text to write to the clipboard
 */
export async function writeToClipboard(text: string): Promise<void> {
  const { Clipboard } = await import("@capacitor/clipboard");
  await Clipboard.write({ string: text });
}
